import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import Switch from 'react-bootstrap-switch'

import Modal from '../../../../../common/components/Modal'
import config from '../../../../../config'

const useSetup = (event) => {
  const [showWarning, setShowWarning] = useState(false)
  const [loadingCost, setLoadingCost] = useState(false)
  const [effectiveRate, setEffectiveRate] = useState(null)
  const switchRef = useRef()
  //to hold the action while it is confirmed by the user
  const headers = {
    'Wsc-api-key': config.apiAuthentication.vendorKey,
    Authorization: config.apiAuthentication.vendorName,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  useEffect(() => {
    if (!loadingCost && effectiveRate === null) {
      setLoadingCost(true)
      axios
        .post(
          `${config.uris.crud}Clients/getLiveCaptionRates`,
          { clientID: event.clientID },
          { headers }
        )
        .then((res) => {
          setLoadingCost(false)
          if (res.data && res.data.data) {
            setEffectiveRate(res.data.data.effectiveRate)
          }
        })
    }
  }, [])
  return { showWarning, setShowWarning, effectiveRate, switchRef, loadingCost }
}

const getIsDisabled = (eventStatus) => {
  const disabled = [
    'disconnected',
    'starting',
    'publishing',
    'published',
    'stopping',
    'live',
    'on break',
  ].includes(eventStatus)
  return disabled
}

const ConfirmationModal = (props) => {
  const { onCancel, onConfirm, effectiveRate } = props
  return (
    <Modal
      cancelModal={onCancel}
      saveAction={
        <button className='btn btn-primary' onClick={onConfirm}>
          Enable AI Captions
        </button>
      }
    >
      <Modal.Header>Enable Transcription</Modal.Header>
      <Modal.Body>
        <div className='alert alert-danger'>
          <h4>
            Enabling live AI captions will incur a cost of ${effectiveRate} per
            minute.
          </h4>
          <p>Are you sure you want to enable this?</p>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  )
}

const AiCaptions = (props) => {
  const { event, onChange } = props

  const { showWarning, setShowWarning, effectiveRate, switchRef, loadingCost } = useSetup(event)
  const disabled = getIsDisabled(event.eventStatus)

  if (loadingCost || effectiveRate === null) {
    return <div>Loading...</div>
  }

  const onModalCancel = () => setShowWarning(false)
  const onModalConfirm = () => {
    setShowWarning(false)
    onChange(switchRef, true)
  }
  const onSwitchChange = (el, value) => {
    if (value === true) {
      // show modal before making the toggle switch
      setShowWarning(true)
    } else {
      onChange(el, value)
    }
  }

  return (
    <>
      {showWarning ? (
        <ConfirmationModal
          onCancel={onModalCancel}
          onConfirm={onModalConfirm}
          effectiveRate={effectiveRate}
        />
      ) : null}
      <div
        style={
          disabled
            ? { display: 'block', cursor: 'not-allowed' }
            : { display: 'block' }
        }
      >
        <Switch
          ref={switchRef}
          disabled={disabled}
          onChange={onSwitchChange}
          value={
            event.liveAiCaptions === true || !!event.liveAiCaptions.isEnabled
          }
          animate={false}
        />
      </div>
    </>
  )
}

export default AiCaptions
